import { render, staticRenderFns } from "./excel-format-error-dialog.vue?vue&type=template&id=a51252e6&scoped=true&"
import script from "./excel-format-error-dialog.vue?vue&type=script&lang=js&"
export * from "./excel-format-error-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51252e6",
  null
  
)

export default component.exports